var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _path, _path2, _path3, _rect227, _rect228, _rect229;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoposQrCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1160px",
    height: "1160px",
    viewBox: "0 0 1160 1160",
    enableBackground: "new 0 0 1160 1160",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1160,
    height: 1160,
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,80)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,0) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,0) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,0) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,0) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,0) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,0) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,40) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,40) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,40) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,40) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,40) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,80) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440,80) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,80) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,80) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,120) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,120) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,120) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,120) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,160) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440,160) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,160) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,160) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,160) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,200) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,200) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,240) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,240) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,240) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,240) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,240) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,280) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,280) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,280) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,320) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,320) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,320) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,320) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,320) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,320) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,320) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,320) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(760,320) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(880,320) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,320) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(760,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(920,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,360) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,400) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,400) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,400) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,400) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,400) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,400) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,400) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,400) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,400) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,400) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,400) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(880,400) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,400) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,440) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,440) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,440) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440,440) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,440) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(680,440) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,440) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(760,440) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,440) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,480) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,480) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,480) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,480) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,480) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,480) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,480) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,480) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,480) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,480) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(760,480) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,480) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,520) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,520) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,520) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,520) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,520) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,520) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,520) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(680,520) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,520) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(760,520) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(920,520) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,520) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(160,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(680,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(880,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,560) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(760,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(800,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,600) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(280,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(680,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(760,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(800,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(920,640) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,680) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,680) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,680) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,680) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,680) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,680) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(800,680) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,680) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,720) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,720) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,720) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440,720) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,720) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,720) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(800,720) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,720) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,760) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,760) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(800,760) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(920,760) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,800) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,800) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440,800) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,800) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,800) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,800) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,800) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(680,800) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,800) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(760,800) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(800,800) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(920,800) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,800) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(360,840) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,840) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,840) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,840) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,840) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(680,840) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(800,840) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(880,840) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(920,840) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,880) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,880) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,880) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,880) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,880) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,880) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(680,880) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(760,880) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(800,880) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,880) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(920,880) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,880) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(440,920) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(480,920) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,920) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(600,920) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,920) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(680,920) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,920) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(760,920) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(800,920) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320,960) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(400,960) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,960) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(560,960) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640,960) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(840,960) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(960,960) scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) scale(2.8, 2.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    style: {
      fill: "none"
    },
    width: 70,
    height: 70
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(720,0) scale(2.8, 2.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    style: {
      fill: "none"
    },
    width: 70,
    height: 70
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,720) scale(2.8, 2.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    style: {
      fill: "none"
    },
    width: 70,
    height: 70
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,80) scale(1.2, 1.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(800,80) scale(1.2, 1.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,800) scale(1.2, 1.2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoposQrCode);
export default __webpack_public_path__ + "static/media/gopos-qr-code.4b6bc1b9.svg";
export { ForwardRef as ReactComponent };